import { TextInput, TextInputProps } from "react-native-paper";

type InputProps = TextInputProps;

export const OutlinedInput = (props: InputProps) => {
  return (
    <TextInput
      mode="outlined"
      autoCapitalize={props.autoCapitalize || "none"}
      autoFocus={props.autoFocus}
      {...props}
      style={props.style}
      outlineStyle={props.outlineStyle}
    />
  );
};
